export const note_structure = {
    full_note: "",
    alert: false,
    discount: null,
    dont_adjust_oh: false,
    extra_price: null,
    sell_price: null,
}

export const stock_structure = {
    author: "",
    available_on_hand: 0,
    available_on_order:0,
    backroom: null,
    binding: "",
    bisac: "",
    bisac_description: "",
    carton_quantity: null,
    category_1: "",
    category_2: "",
    category_discount : 0,
    category_description: "",
    category_fb_point: "",
    category_tax_code: "",
    condition_code: "",
    cost: 0,
    cost_lock: "",
    has_message : false,
    held_point_of_sale: 0,
    last_received : 0,
    last_sold : 0,
    minimum_onhand: 0,
    note: note_structure,
    on_order: 0,
    original_publisher: "",
    out_of_stock_status: "",
    peer_on_order : 0,
    peer_onhand : 0,
    pending_on_order: 0,
    pending_return: 0,
    peer_total_locations : 0,
    price: 0,
    rank: 0,
    primary_code: "",
    profit_cost: 0,
    profit_sell: 0,
    publication_date: null,
    receive_date: null,
    returnable: "",
    secondary_code: "",
    section: "",
    sell_price: 0,
    sold_1: "",
    sold_10: "",
    sold_11: "",
    sold_12: "",
    sold_13: "",
    sold_14: "",
    sold_2: "",
    sold_3: "",
    sold_4: "",
    sold_5: "",
    sold_6: "",
    sold_7: "",
    sold_8: "",
    sold_9: "",
    special_on_order: 0,
    special_on_order_pending : 0,
    status: "",
    stock_id: "",
    stocked_1: "",
    stocked_10: "",
    stocked_11: "",
    stocked_12: "",
    stocked_13: "",
    stocked_14: "",
    stocked_2: "",
    stocked_3: "",
    stocked_4: "",
    stocked_5: "",
    stocked_6: "",
    stocked_7: "",
    stocked_8: "",
    stocked_9: "",
    supplier_1: "",
    supplier_2: "",
    supplier_3: "",
    peer_header: "",
    peer_1: "",
    peer_10: "",
    peer_11: "",
    peer_12: "",
    peer_13: "",
    peer_14: "",
    peer_2: "",
    peer_3: "",
    peer_4: "",
    peer_5: "",
    peer_6: "",
    peer_7: "",
    peer_8: "",
    peer_9: "",
    peer_total: "",
    title: "",
    total_onhand: 0,
    total_received: 0,
    total_returned: 0,
    total_sold: 0,
    used_condition: "",
    weight: "",
    tax_code: "",
    colour_1: "",
    colour_10: "",
    colour_11: "",
    colour_12: "",
    colour_13: "",
    colour_14: "",
    colour_2: "",
    colour_3: "",
    colour_4: "",
    colour_5: "",
    colour_6: "",
    colour_7: "",
    colour_8: "",
    colour_9: "",
}

export const order_structure = {

    cancel_date: 0,
    clerk_code: "",
    condition_code: "",
    customer: null,
    customer_po: "",
    id: "",
    invoice_price: 0,
    is_prepay: false,
    is_single_title_order: false,
    ms_split: [],
    note: "",
    order_number: "",
    order_separator: "",
    po_number: "",
    primary_code: "",
    quantity: 0,
    review_days: 0,
    status: "Pend",
    status_date: 0,
    supplier: "",
    supplier_discount: 40,
    invoice : "",
    invoice_date : 0,

}